import MultiMix from './MultiMix.js';
import Savable from './Savable.js';
import MultiSequencerEngine from '../MultiSequencerEngine.js';

class MixableSequencerEngine extends Savable(MultiMix(MultiSequencerEngine)) {
}

export default MixableSequencerEngine;
